import React from 'react';
import { motion } from 'framer-motion';
import { VisualOverlay } from './VisualOverlay';
import type { ChapterVisual } from '../types/pulse';
interface CinematicVisualProps {
  image: string;
  visual: ChapterVisual;
  accent: string;
  caption: string;
}
export function CinematicVisual({
  image,
  visual,
  accent,
  caption
}: CinematicVisualProps) {
  return <figure className="relative h-[300px] w-full shrink-0 overflow-hidden bg-mist-100" data-id="element-394" data-mp="wq48mgk3djdy">
      <motion.img src={image} alt="" initial={{
      scale: 1.18
    }} animate={{
      scale: 1.03
    }} transition={{
      duration: 9,
      ease: 'easeOut'
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-395" data-mp="11ph6rxgeycvu" />
      <VisualOverlay variant={visual} accent={accent} data-id="element-396" data-mp="1fj84m8ks88bq" />
      <figcaption className="absolute bottom-12 left-5 rounded-full border border-navy-900/10 bg-white/85 px-3 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-navy-700 backdrop-blur-md" data-id="element-397" data-mp="1fl2odjkbhue8">
        {caption}
      </figcaption>
    </figure>;
}